import { render } from "./BaseBgSkeleton.vue?vue&type=template&id=3a90a6ac&scoped=true"
import script from "./BaseBgSkeleton.vue?vue&type=script&lang=js"
export * from "./BaseBgSkeleton.vue?vue&type=script&lang=js"

import "./BaseBgSkeleton.vue?vue&type=style&index=0&id=3a90a6ac&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a90a6ac"]])

export default __exports__